import "./tabView.scss";

import PropTypes from "prop-types";
import React from "react";

import keyConstants from "../../constants/keyConstants";
import { PropTypeShapes } from "../../types";
import TabButton from "./TabButton";

const renderChildren = props => {
  return props.tabs.map((tab, index) => (
    <TabButton
      key={index}
      onClick={() => props.onClick(index)}
      icon={tab.icon}
      badge={tab.badge}
      badgeColor={tab.badgeColor}
      label={tab.label}
      showLabel={props.showLabels}
      active={index === props.activeTab}
      pulse={props.pulsateIconId && props.pulsateIconId === tab.interfaceId}
    />
  ));
};

const TabBar = props => {
  const onKeyDown = e => {
    let nextTab = props.activeTab;
    const tabCount = props.tabs.length;
    if (e.key === keyConstants.Right) {
      nextTab += 1;
      e.stopPropagation();
      e.preventDefault();
    } else if (e.key === keyConstants.Left) {
      nextTab += tabCount - 1;
      e.stopPropagation();
      e.preventDefault();
    }
    props.onClick(nextTab % tabCount);
  };

  return (
    <div className={"tabBar"}>
      <div className={"tabBarOutline"} tabIndex={0} onKeyDown={onKeyDown}>
        {renderChildren(props)}
      </div>
    </div>
  );
};

TabBar.propTypes = {
  tabs: PropTypeShapes.inspectorTabArray.isRequired,
  showLabels: PropTypes.bool,
  activeTab: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  pulsateIconId: PropTypes.string
};

export default TabBar;
